module.exports = __webpack_public_path__ + "img/traditional-d.46736e2.jpg";